var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "users-row-email" }, [
      _vm.device.ring_solutions_url
        ? _c("span", [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.device.ring_solutions_url,
                  target: "_blank",
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.device.name) + "\n      ")]
            ),
          ])
        : _c("span", [
            _vm.device.type == "racp"
              ? _c("span", [
                  _c("a", [
                    _vm._v(
                      "\n          " + _vm._s(_vm.device.name) + "\n        "
                    ),
                  ]),
                ])
              : _c(
                  "span",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "Device",
                            params: { doorbot_id: _vm.device.doorbot_id },
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.device.name || "-") +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
          ]),
      _vm._v(" "),
      _c("div", { staticStyle: { float: "right" } }, [
        _vm._v("\n      " + _vm._s(_vm.product.description) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ring-card__input-label" }, [
      _c("span", [
        _vm._v(_vm._s(_vm.device.mac_address || _vm.device.hardware_id) + " "),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { float: "right" } }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm._f("capitalize")(
                _vm.getRBACRoleDescription(_vm.userRole || _vm.device.role)
              )
            ) +
            "\n    "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }